// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__yhql7","description":"PatientConsentPreview_description__2L2bY"};